import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

/* eslint-disable no-console */ // While in dev preview console.info will be used
/* eslint-disable react/no-unused-prop-types */
import { PureComponent } from 'react';

/**
 * Result that is returned by any Validator
 */


/**
 * Result that is returned by any Validator
 */

var Validator = function (_PureComponent) {
  _inherits(Validator, _PureComponent);

  function Validator() {
    _classCallCheck(this, Validator);

    return _possibleConstructorReturn(this, (Validator.__proto__ || _Object$getPrototypeOf(Validator)).apply(this, arguments));
  }

  _createClass(Validator, [{
    key: 'render',


    /** Valiate a value using the function & options passed in as props  */
    /*validate = (value:string) => {
      let valid:boolean = this.props.func(value, this.props.options);
      // Invert result if validOn prop is false
      //if(!this.props.validOn && !valid) valid = true;
      return {
          valid,
          message: (valid)? this.props.valid : this.props.invalid
      }
    };
    */

    value: function render() {
      return null;
    }
  }]);

  return Validator;
}(PureComponent);

Validator.defaultProps = {
  func: {},
  validOnFalse: false,
  valid: '',
  invalid: ''
};
export default Validator;